import Vue from "vue";
import Vuex from "vuex";

import flow from "./modules/flow";
import session from "./modules/session";
import ui from "./modules/ui";
import persistPlugin from "./persist";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: { flow, session, ui },
  plugins: [persistPlugin],
});
